module.exports = __webpack_public_path__ + "static/media/paperclip.02f56628.svg";